module.exports = __webpack_public_path__ + "img/icon_map_36_off_010.30f5cdbf.png";